export const BT_Acquisition_FTTC = {
  conditions: [
    {
      conditionData: {
        id: 1,
        name: "BT Acquisition FTTC"
      },
      data: {
        options: {
          numberOfPlansToDisplay: "100",
          planStyle: "BASELINE",
          pageToShowEntertainment: "plan"
        },
        defaultPlanByDevice: {
          BT_ROUTER: "PLAN_1"
        },
        planOrderByDevice: {
          BT_ROUTER: ["PLAN_1", "PLAN_2", "PLAN_3", "PLAN_4"]
        },
        plans: [
          {
            id: "PLAN_1",
            data: {
              name: "Fibre Essential",
              icon: "BT",
              downloadSpeed: 40,
              tagline:
                "Everyday browsing and streaming on one or two devices at once.",
              data: "1000",
              contractLength: "24",
              downloadSpeedUnit: "Mb",
              lineRental: "Includes BT line rental"
            },
            devices: {
              BT_ROUTER: {
                maf: 25.0,
                upfront: 19.99,
                ooc: 8
              }
            },
            benefits: [
              "BT_EXPERT_SERVICE",
              "BT_SPEED_GUARANTEE",
              "BT_POWERFUL_HUB",
              "BT_UNRIVALLED_SECURITY"
            ]
          },
          {
            id: "PLAN_2",
            data: {
              name: "Full Fibre 100",
              icon: "BT",
              downloadSpeed: 100,
              tagline: "Do more online with our Full Fibre connection.",
              data: "1000",
              contractLength: "24",
              downloadSpeedUnit: "Mb",
              lineRental: "Includes BT line rental"
            },
            devices: {
              BT_ROUTER: {
                maf: 35,
                upfront: 19.99,
                ooc: 8
              }
            },
            benefits: [
              "BT_INSTANT_ON_PLACEHOLDER",
              "BT_EXPERT_SERVICE",
              "BT_SPEED_GUARANTEE",
              "BT_POWERFUL_HUB",
              "BT_UNRIVALLED_SECURITY"
            ]
          },
          {
            id: "PLAN_3",
            data: {
              name: "Full Fibre 300",
              icon: "BT",
              nameArray: ["Full Fibre 300", "Full Fibre 500"],
              downloadSpeed: 300,
              downloadSpeedArray: [300, 500],
              tagline:
                "Stream, game and download in HD on lots of devices at once.",
              data: "1000",
              contractLength: "24",
              downloadSpeedUnit: "Mb",
              lineRental: "Includes BT line rental"
            },
            devices: {
              BT_ROUTER: {
                maf: 45,
                upfront: 19.99,
                ooc: 8
              }
            },
            benefits: [
              "BT_INSTANT_ON_PLACEHOLDER",
              "BT_EXPERT_SERVICE",
              "BT_SPEED_GUARANTEE",
              "BT_POWERFUL_HUB",
              "BT_UNRIVALLED_SECURITY"
            ]
          },
          {
            id: "PLAN_4",
            data: {
              name: "Full Fibre 900",
              icon: "BT",
              downloadSpeed: 900,
              tagline: "For busy homes with everything connected at once.",
              data: "1000",
              contractLength: "24",
              downloadSpeedUnit: "Mb",
              lineRental: "Includes BT line rental"
            },
            devices: {
              BT_ROUTER: {
                maf: 60,
                upfront: 19.99,
                ooc: 8
              }
            },
            benefits: [
              "BT_INSTANT_ON_PLACEHOLDER",
              "BT_EXPERT_SERVICE",
              "BT_SPEED_GUARANTEE",
              "BT_POWERFUL_HUB",
              "BT_UNRIVALLED_SECURITY"
            ]
          }
        ]
      }
    }
  ]
}
